<div #destination class="searchInputActivity__cont">
  <div class="searchInputActivity__input" [class.results]="isResultsPage">
    <app-ds-input-text
      [isReadonly]="true"
      [isDisabled]="isDisabled"
      [icon]="icon"
      [size]="inputSize"
      [filled]="filled"
      [staticFilled]="staticFilled"
      [label]="countryCode"
      [placeholder]="countryCode"
      [value]="inputValue"
      [isFailed]="showError"
      (clickEvent)="toggleInput()">
    </app-ds-input-text>
  </div>
  <div class="searchInputActivity__autocomplete">
    <app-search-input-autocomplete
      [searchType]="searchType"
      [query]="query"
      [isMobile]="isMobile"
      [viewAutocomplete]="showInput"
      [inputPlaceListIcon]="icon"
      [inputPlaceListLabel]="countryCode"
      [title]="countryCode"
      [inputPlaceListPlaceholder]="'SEARCH_MODULE.LOCATION_SEARCH.YOUR_DESTINATION' | transloco"
      [isLoadingAutocompletePlaces]="isLoadingAutocompletePlaces"
      [activityAndDestinationAutocomplete]="resultsPlaces"
      [isCollapsableList]="true"
      (closeAutocomplete)="toggleInput()"
      (setQuery)="setQuery($event)"
      (selectPopularPlace)="selectPopularPlace($event)"
      (selectActivityEvent)="selectActivityEvent($event)"
      (selectExtraDestinationEvent)="selectExtraDestinationEvent($event)"
      (popularSelected)="popularSelected.emit($event)">
    </app-search-input-autocomplete>
  </div>
</div>
